import { barChartHeight } from "./barChartHeight";
import renderChart from "./renderChart";

export const multiBarChartConfig = (data, options) => {
  const { categories, series } = data;

  return {
    chart: {
      type: "bar",
      height: barChartHeight(categories.length * series.length)
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true
    },
    xAxis: {
      categories: categories,
      title: {
        text: null
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: options.label,
        align: "high"
      },
      labels: {
        overflow: "justify"
      }
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b>"
    },
    plotOptions: {
      bar: {
        dataLabels: {
          align: "left",
          enabled: true,
          inside: true,
          formatter: function () {
            return this.y > 0 ? this.y : null;
          },
          style: {
            color: "contrast"
          }
        },
        groupPadding: 0.1
      }
    },
    series: series
  };
};

const multiBarChart = (element, data, options) => {
  return renderChart(element, multiBarChartConfig(data, options), options);
};

export default multiBarChart;
